var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:[
        'btn-default',
        { 'bg-btn-tool-bar': _vm.btnToolBar },
        { 'bg-btn-save-modal': _vm.btnSaveModal },
        { 'bg-btn-delete-modal': _vm.btnDeleteModal }
    ],attrs:{"size":_vm.size,"type":_vm.type,"loading":_vm.loading,"icon":_vm.icon,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }